import moment from 'moment'
import { FC } from 'react'

import { EuiSpacer, EuiText, EuiFlexGroup, EuiFlexItem, EuiTitle } from '@elastic/eui'

import { MasterCampaignPlan } from 'api/entities/MasterCampaignPlan'
import { calculateEndDate } from 'utils/MasterCampaignPlanUtils'

import Budget from '../Budget'
import RenderCustomSections from '../RenderCustomSections'
import CampaignTimeline from '../ExecutiveSummary/CampaignTimeline'
import TabPageHeader from '../TabPageHeader'
import { CampaignCard } from './CampaignCard'

export interface MediaPlanProps {
  masterCampaignPlan: MasterCampaignPlan
}

const MediaPlan: FC<MediaPlanProps> = ({ masterCampaignPlan }) => {
  const campaigns = masterCampaignPlan.masterCampaignStub?.campaignBuilders || []
  const planStartDate = moment(masterCampaignPlan.aiUsedStartDate)
  const planDurationMonths = masterCampaignPlan.aiUsedDurationInMonths
  const section = masterCampaignPlan.mediaPlanSection

  const pageTitle = section?.pageTitle || 'Media Plan'
  const campaignDetailsTitle = section?.campaignDetailsTitle || 'Campaign Details'

  const listCampaigns = [...campaigns]
    .sort((a, b) => moment(a.startDate).valueOf() - moment(b.startDate).valueOf())
    .map(builder => {
      const calculatedEndDate = calculateEndDate(builder)
      return (
        <div key={builder.id} style={{ marginBottom: '1rem' }}>
          <CampaignCard builder={{ ...builder, endDate: calculatedEndDate }} />
        </div>
      )
    })

  return (
    <>
      <TabPageHeader title={pageTitle} />

      {section?.budget?.hideAll !== true && (
        <>
          <Budget campaigns={campaigns} useMediaPlanWording={true} section={section?.budget} />
          <EuiSpacer size='xl' />
        </>
      )}

      <RenderCustomSections sections={section?.aboveCampaignTimeline} />

      <CampaignTimeline campaigns={campaigns} planStartDate={planStartDate} planDurationMonths={planDurationMonths} isHoverable isClickable />

      <EuiSpacer size='xxl' />

      <RenderCustomSections sections={section?.aboveCampaignDetails} />

      <EuiFlexGroup>
        <EuiFlexItem>
          <EuiFlexGroup alignItems='center'>
            <EuiFlexItem grow={false}>
              <EuiTitle size='s'>
                <h4>{campaignDetailsTitle}</h4>
              </EuiTitle>
            </EuiFlexItem>
          </EuiFlexGroup>
        </EuiFlexItem>
      </EuiFlexGroup>

      <EuiSpacer size='m' />

      <div style={{ width: '100%' }}>{listCampaigns}</div>

      {campaigns.length === 0 && (
        <EuiText>
          <p>No campaigns have been configured for this plan yet.</p>
        </EuiText>
      )}
    </>
  )
}

export default MediaPlan
